/* ─── Variant classes ─── */

.display-lg {
  font: var(--type-display-lg);
  letter-spacing: var(--tracking-display-lg);
}

.display-md {
  font: var(--type-display-md);
  letter-spacing: var(--tracking-display-md);
}

.display-sm {
  font: var(--type-display-sm);
  letter-spacing: var(--tracking-display-sm);
}

.headline-lg {
  font: var(--type-headline-lg);
  letter-spacing: var(--tracking-headline-lg);
}

.headline-md {
  font: var(--type-headline-md);
  letter-spacing: var(--tracking-headline-md);
}

.headline-sm {
  font: var(--type-headline-sm);
  letter-spacing: var(--tracking-headline-sm);
}

.title-lg {
  font: var(--type-title-lg);
  letter-spacing: var(--tracking-title-lg);
}

.title-md {
  font: var(--type-title-md);
  letter-spacing: var(--tracking-title-md);
}

.title-sm {
  font: var(--type-title-sm);
  letter-spacing: var(--tracking-title-sm);
}

.body-lg {
  font: var(--type-body-lg);
  letter-spacing: var(--tracking-body-lg);
}

.body-md {
  font: var(--type-body-md);
  letter-spacing: var(--tracking-body-md);
}

.body-sm {
  font: var(--type-body-sm);
  letter-spacing: var(--tracking-body-sm);
}

.label-lg {
  font: var(--type-label-lg);
  letter-spacing: var(--tracking-label-lg);
}

.label-md {
  font: var(--type-label-md);
  letter-spacing: var(--tracking-label-md);
}

.label-sm {
  font: var(--type-label-sm);
  letter-spacing: var(--tracking-label-sm);
}

/* ─── Color classes ─── */

.color-default {
  color: var(--md-on-surface);
}

.color-variant {
  color: var(--md-on-surface-variant);
}

.color-primary {
  color: var(--md-primary);
}

.color-error {
  color: var(--md-error);
}

.color-success {
  color: var(--status-success);
}

.color-inherit {
  color: inherit;
}

/* ─── Alignment ─── */

.align-start {
  text-align: start;
}

.align-center {
  text-align: center;
}

.align-end {
  text-align: end;
}

/* ─── Truncation ─── */

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* clamp is applied via inline style (--line-clamp) */
.clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: var(--line-clamp);
  overflow: hidden;
}

/* Declared after every role: a role's `font` shorthand resets font-weight. */
.weight-bold {
  font-weight: 600;
}
